import MarketPersonalInfoCardComponent from './MarketPersonalInfoCardContainer';

export default MarketPersonalInfoCardComponent;
